module.exports = __webpack_public_path__ + "static/logosheet-750-fa17daa133d0f4f34f7555db27719c44.jpg";